var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.item[_vm.header.value] ? _vm.formatDate(_vm.item[_vm.header.value] * 1000, 'DD-MM-YYYY') : ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }